var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import createCoMallElement from './createCoMallElement';
/**
 * 以 CoMallElement 元素为样板克隆并返回新的 CoMallElement 元素
 * @param element
 * @param props
 * @param children
 */
function cloneCoMallElement(element, props, ...children) {
    const { type, key: elementKey, props: tempElementProps } = element;
    const { children: elementChildren } = tempElementProps, elementProps = __rest(tempElementProps, ["children"]);
    let mergeElementProps = Object.create(null);
    if (props) {
        const { key } = props, other = __rest(props, ["key"]);
        mergeElementProps = Object.assign(Object.assign(Object.assign({}, elementProps), other), { key: elementKey });
        if (key) {
            mergeElementProps.key = key;
        }
    }
    if (children && children.length > 0) {
        return createCoMallElement(type, mergeElementProps, ...children);
    }
    if (elementChildren && elementChildren.lnegth > 0) {
        return createCoMallElement(type, mergeElementProps, ...elementChildren);
    }
    return createCoMallElement(type, mergeElementProps);
}
export default cloneCoMallElement;
//# sourceMappingURL=cloneCoMallElement.js.map